"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var spaui_1 = require("@tencent/spaui");
var MetaInput = function MetaInput(props, ref) {
  var inputElementRef = props.inputElementRef,
    _a = props.icon,
    icon = _a === void 0 ? null : _a,
    _b = props.useTextarea,
    useTextarea = _b === void 0 ? false : _b,
    _c = props.tagType,
    tagType = _c === void 0 ? '' : _c,
    _d = props.useDiv,
    useDiv = _d === void 0 ? false : _d,
    _e = props.muiltline,
    muiltline = _e === void 0 ? false : _e,
    _f = props.hasWechatEmoji,
    hasWechatEmoji = _f === void 0 ? false : _f,
    value = props.value,
    onInput = props.onInput,
    _g = props.onChange,
    onChange = _g === void 0 ? function () {
      return void 0;
    } : _g,
    inputId = props.inputId,
    otherProps = __rest(props, ["inputElementRef", "icon", "useTextarea", "tagType", "useDiv", "muiltline", "hasWechatEmoji", "value", "onInput", "onChange", "inputId"]);
  var
    // className,
    _h = otherProps.addons,
    // className,
    addons = _h === void 0 ? null : _h,
    legacy = otherProps.legacy;
  var dom;
  if (useDiv) {
    otherProps.contentEditable = true;
    dom = react_1["default"].createElement("div", __assign({}, otherProps, {
      ref: inputElementRef || ref,
      className: (0, classnames_1["default"])("meta-input".concat(legacy ? '-legacy' : ''), 'spaui-input spaui-div-input', {
        'emoji-input': hasWechatEmoji,
        muiltline: muiltline
      }),
      onInput: onInput
    }));
  }
  return react_1["default"].createElement("div", __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])("meta-input-wrapper".concat(legacy ? '-legacy' : ''), {
      'with-addons': addons,
      'with-icon': icon
    }),
    supportAllEvents: true
  }, MetaInput)), icon ? react_1["default"].createElement("div", {
    className: "meta-input-icon"
  }, icon) : null, !useDiv ? react_1["default"].createElement(spaui_1.Input, __assign({
    tagType: useTextarea ? 'textarea' : tagType
  }, otherProps, {
    id: inputId || otherProps.id,
    ref: inputElementRef || ref,
    className: (0, classnames_1["default"])("meta-input".concat(legacy ? '-legacy' : ''),
    // className,
    {
      'spaui-textarea': useTextarea
    }),
    onChange: onChange,
    value: value
  })) : dom, addons, react_1["default"].createElement("i", {
    className: "meta-input-border".concat(legacy ? '-legacy' : '')
  }));
};
(0, spaui_utils_1.setComponentMark)(MetaInput, info_1["default"]);
exports["default"] = react_1["default"].memo(react_1["default"].forwardRef(MetaInput));